import React, {FunctionComponent, useState} from 'react'
import style from './style.scss'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faChevronUp, faChevronDown, faEdit, faTrashAlt} from '@fortawesome/free-solid-svg-icons'
import ManagePerson from './ManagePerson/ManagePerson'
import {useTranslation} from 'react-i18next'
import {useDispatch} from 'react-redux'
import {deletePersonTarget, updatePersonTarget} from '../../../Store/Actions'
import {IProps} from './IProps'
import {ITarget, ITargetPerson} from '../../../Client/ITarget'

const ManageTarget: FunctionComponent<IProps> = ({target}) => {
    const [t] = useTranslation()

    const dispatch = useDispatch()

    const [isDropDownVisible, setIsDropDownVisible] = useState(true)

    const onPersonDelete = (person: ITargetPerson) => {
        const newTarget = Object.assign({}, target)
        newTarget.persons = newTarget.persons.filter(value => value !== person)

        const data = {
            id: newTarget.id,
            amount: newTarget.amount,
            period: newTarget.period,
            persons: newTarget.persons
        }

        dispatch(updatePersonTarget(data))
    }

    const toggleDropDownVisibility = () => {
        isDropDownVisible ? setIsDropDownVisible(false) : setIsDropDownVisible(true)
    }

    const onTargetDelete = (removeTarget: ITarget) => {
        dispatch(deletePersonTarget(removeTarget))
    }

    return (
        <>
            <div className={style.manageTarget}>
                <FontAwesomeIcon onClick={() => toggleDropDownVisibility()} className={style.leftIcon}
                                 icon={isDropDownVisible ? faChevronUp : faChevronDown}/>
                <div className={style.leftColumn}>
                    <p>{target.amount} {t('euro')}</p>
                </div>
                <div className={style.rightColumn}>
                    <p>{target.persons.length} {t('people')}</p>
                </div>
                <div className={style.rightIcons}>
                    <a href={`/hr/targets/manage/${target.id}/update`} aria-label='edit'>
                        <FontAwesomeIcon className={style.editIcon} icon={faEdit}/>
                    </a>
                    <a aria-label='delete'>
                        <FontAwesomeIcon onClick={() => onTargetDelete(target)}
                                         className={style.deleteIcon}
                                         icon={faTrashAlt}/>
                    </a>
                </div>
            </div>
            <ul className={isDropDownVisible ? style.dropDownVisible : style.dropDownInvisible}>
                {target.persons.length >= 1
                    ? target.persons.map(
                        (person) => <ManagePerson key={person.id} person={person} onPersonDelete={onPersonDelete}/>
                    ) : (
                        <p>{t('No persons have been added to this target. Click on the edit button to do so')}</p>
                    )
                }
            </ul>
        </>
    )
}

export default ManageTarget
